import type { PageContext } from "vike/types";

import { isLocale, LOCALE_DEFAULT } from "@/0-app/providers/I18nProvider";

export function onBeforeRoute(pageContext: PageContext) {
  const { pathname } = pageContext.urlParsed;
  const parts = pathname.split("/").filter(Boolean); // ["en","about"]
  const maybeLocale = parts[0];

  let locale = LOCALE_DEFAULT;
  let rest = pathname;

  if (maybeLocale && isLocale(maybeLocale)) {
    locale = maybeLocale;
    rest = "/" + parts.slice(1).join("/"); // "/about" or ""
    if (rest === "/") rest = "/";
    if (rest === "") rest = "/";
  }

  return {
    pageContext: {
      locale,
      urlLogical: rest,
    },
  };
}
